﻿import { ssApiService } from './ss-api.service';
import { Injectable } from '@angular/core';
import 'rxjs';
import 'rxjs/add/operator/toPromise';

import { UserRoleTypes, UserRoleItem, UserRoleItemArray } from '../models/domain/user.roles';
import { GlobalService } from './global.service';

@Injectable()
export class UserRolesService {

    // EVENTS
    // public onAllPossibleTagsLoaded = new Subject<TagArray>();

    // vars
    UserRole: UserRoleItem = new UserRoleItem;

    AllUserRoles = new UserRoleItemArray();

    // AuthSubscription: any;

    constructor( private api: ssApiService, private gb: GlobalService ) {
        this.SetupUserRole();
    }


    SetUpRoles() {

        let DevRole = new UserRoleItem;
        DevRole.Role = UserRoleTypes.Developer;
        this.AllUserRoles.push(DevRole);

        let AdminRole = new UserRoleItem;
        AdminRole.Role = UserRoleTypes.Administrator;
        this.AllUserRoles.push(AdminRole);

        let DefaultRole = new UserRoleItem;
        DefaultRole.Role = UserRoleTypes.TechSupport;
        this.AllUserRoles.push(DefaultRole);

        // console.log("ROLES ARE SET UP : ", this.AllUserRoles );

    }

    CheckUserRole( email: string ) {
        // console.log("User Role Email : " + email );
    }

    public SetupUserRole() {

        

        if (this.gb.Email == undefined)
            return;

        switch( this.gb.Email.toLowerCase() ) {
            
            case "fausto@structurestudios.com" :
            case "michael@structurestudios.com" :
            case "nickolas@structurestudios.com" :
                this.UserRole.Role = UserRoleTypes.Developer;
                break;   

            case "stefanie@structurestudios.com" :
            case "stefanie@structure.com" :
            case "james@structurestudios.com" :
            case "james@structure.com" :
            case "whitney@structurestudios.com" :
                    this.UserRole.Role = UserRoleTypes.Administrator;
                break;

            default:
                this.UserRole.Role = UserRoleTypes.TechSupport;
                break;

        }


        console.log("user role = ", this.UserRole);
            

    }

    public RestrictedAccess( RestrictionLevel: UserRoleTypes ): boolean {
        if (this.UserRole.Role == UserRoleTypes.Developer) {
            return true; // IS DEVELOPER
        } else if ( this.UserRole.Role == UserRoleTypes.Administrator && RestrictionLevel != UserRoleTypes.Developer ) {
            return true; // IS ADMIN
        } else if ( this.UserRole.Role == UserRoleTypes.TechSupport && RestrictionLevel != UserRoleTypes.Developer && RestrictionLevel != UserRoleTypes.Administrator ) {
            return true; //TECH gets access to tech, sales, and training
        } else if ( this.UserRole.Role == UserRoleTypes.Sales && RestrictionLevel == UserRoleTypes.Sales ) {
            return true;
        } else if ( this.UserRole.Role == UserRoleTypes.Training && RestrictionLevel == UserRoleTypes.Training ) {
            return true;
        }
        return false;
    }

    public TestUserRole( NewRole: UserRoleTypes ) {
        this.UserRole.Role = NewRole;
        setTimeout( () => {
            this.UserRole.Role = UserRoleTypes.Developer;
        }, 2000);
    }

}
